export enum ConfigStrategy {
  LOCAL_STORAGE
}
